/**
 * Utility to determine application domains and URLs based on environment.
 * Development / Test / Localhost: traderflowtest.com
 * Production: traderflow.com
 */

export const getAppBaseUrl = () => {
  // 1. Check Gatsby env var if explicitly set
  const envDomain = process.env.GATSBY_TF_DOMAIN;
  if (envDomain) {
    const cleanDomain = envDomain.replace(/^www\./, '').replace(/\/$/, '');
    return `https://app.${cleanDomain}`;
  }

  // 2. Check browser window location if available
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname || '';
    const host = window.location.host || '';

    // If on test / dev domain
    if (hostname.includes('traderflowtest.com')) {
      return 'https://app.traderflowtest.com';
    }

    // If on production domain
    if (hostname.includes('traderflow.com')) {
      return 'https://app.traderflow.com';
    }

    // If on local development (localhost / 127.0.0.1)
    if (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.endsWith('.local')
    ) {
      return 'https://app.traderflowtest.com';
    }

    // General fallback based on current host
    if (host) {
      return `${window.location.protocol}//app.${host.replace(/^www\./, '')}`;
    }
  }

  // 3. Check NODE_ENV during SSR
  if (process.env.NODE_ENV === 'development') {
    return 'https://app.traderflowtest.com';
  }

  // 4. Default to production
  return 'https://app.traderflow.com';
};

export const getLoginUrl = (callbackUrl) => {
  const baseUrl = getAppBaseUrl();
  if (callbackUrl) {
    return `${baseUrl}/login?${new URLSearchParams({ callbackUrl }).toString()}`;
  }
  return `${baseUrl}/login`;
};
